import moment from 'moment';

export const formatDate = (date, format = 'DD/MM/YYYY') => {
  if (!date) return '';
  return moment(date).format(format);
};

export const formatDateTime = (date, format = 'DD/MM/YYYY HH:mm') => {
  if (!date) return '';
  return moment(date).format(format);
};

export const formatTime = (date, format = 'HH:mm') => {
  if (!date) return '';
  return moment(date).format(format);
};

export const getRelativeTime = (date) => {
  if (!date) return '';
  return moment(date).fromNow();
};

export const isValidDate = (date) => {
  return moment(date).isValid();
};

export const parseDate = (dateString) => {
  return moment(dateString);
};

// Migrated from Handlers/DateTimeHandler.js
export const DateTimeFormater = (stringValue, formatIn, formatOut) => {
  if (!stringValue) return null;

  const dateFormats = [];
  if (formatIn != null) {
    dateFormats.push(formatIn);
  } else {
    dateFormats.push('DD-MM-YYYY');
    dateFormats.push('YYYY-MM-DD');
    dateFormats.push('YYYY-MM-DDTHH:mm:ss');
    dateFormats.push('YYYY-MM-DDTHH:mm:ss.SSS');
    dateFormats.push('YYYY-MM-DDTHH:mm:ss.SSSZ');
    dateFormats.push('YYYY-MM-DDTHH:mm:ssZ');
    dateFormats.push(moment.ISO_8601);
    dateFormats.push('DD/MM/YYYY');
  }

  const date = moment(stringValue, dateFormats, true);
  if (!date.isValid()) return null;
  return date.format(formatOut);
};
